var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZiplyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 427.67",
    style: {
      enableBackground: "new 0 0 1080 427.67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#008600;}\n\t.st2{fill:#02CAFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 1080,
    height: 427.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "206.2,174.16 151.59,241.9 206.2,241.9 206.2,267.7 107.51,267.7 107.51,253.72 162.12,185.99  107.51,185.99 107.51,160.19 206.2,160.19  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.89,
    y: 160.19,
    className: "st1",
    width: 27.52,
    height: 107.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.45,213.94c0-17.42-11.83-29.67-27.95-29.67c-16.34,0-27.95,12.26-27.95,29.67 c0,17.2,11.61,29.46,27.95,29.46C332.63,243.4,344.45,231.14,344.45,213.94 M372.84,213.94c0,30.53-24.73,55.48-55.48,55.48 c-11.18,0-21.5-3.23-30.1-9.03v59.78h-27.52V160.19h27.52v7.1c8.6-5.59,18.92-8.82,30.1-8.82 C348.11,158.47,372.84,183.2,372.84,213.94"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 380.21,
    y: 107.51,
    className: "st1",
    width: 27.52,
    height: 160.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "517.6,160.19 461.7,308.77 434.18,308.77 453.74,256.73 415.68,160.19 443.21,160.19 467.29,221.04  490.08,160.19  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.89,125.89c0,9.06-7.35,16.41-16.41,16.41c-9.07,0-16.41-7.35-16.41-16.41s7.35-16.41,16.41-16.41 C241.54,109.48,248.89,116.83,248.89,125.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M609.44,160.53v13.73h-33.92v93.43H559.5v-93.43h-14.78v-13.94h14.78v-9.36c0-23.52,11.86-36,32.46-36 c7.49,0,12.49,0.83,17.69,2.7v13.94c-5.83-1.66-10.2-2.71-15.61-2.71c-12.49,0-18.73,7.49-18.73,22.89v8.74H609.44z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 623.59,
    y: 160.11,
    className: "st2",
    width: 16.02,
    height: 107.59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M721.5,172.18c-19.98,0-38.91,16.65-38.91,41.62c0,25.18,18.94,41.83,38.91,41.83 c20.81,0,37.87-15.4,37.87-41.62C759.37,188.42,741.9,172.18,721.5,172.18 M724.42,269.99c-19.98,0-32.88-10.82-41.2-22.89v20.6 h-16.02V115.79h16.02v65.96c8.74-12.9,21.43-23.93,41.2-23.93c25.8,0,51.4,20.39,51.4,55.98 C775.82,249.18,750.43,269.99,724.42,269.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M876.08,207.98c-1.66-19.56-12.9-36.63-34.34-36.63c-18.73,0-32.88,15.61-34.96,36.63H876.08z  M844.65,256.25c14.78,0,25.18-6.04,33.92-15.19l9.99,8.95c-10.82,12.07-23.93,20.19-44.32,20.19 c-29.55,0-53.69-22.68-53.69-56.18c0-31.21,21.85-56.19,51.61-56.19c31.84,0,50.15,25.39,50.15,57.02c0,1.46,0,3.12-0.21,4.99 h-85.32C809.07,243.14,825.72,256.25,844.65,256.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M928.58,267.7h-16.02V160.11h16.02v28.09c7.91-17.9,23.51-30.8,43.91-29.97v17.27h-1.25 c-23.52,0-42.66,16.85-42.66,49.32V267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M643.04,127.66c0,6.1-4.94,11.04-11.04,11.04c-6.1,0-11.04-4.94-11.04-11.04c0-6.1,4.94-11.04,11.04-11.04 C638.1,116.62,643.04,121.57,643.04,127.66"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZiplyLogo);
export default __webpack_public_path__ + "static/media/ziply-logo.e6bf19780f67d6253525d9116284e13a.svg";
export { ForwardRef as ReactComponent };